import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
// import { Redirect } from 'react-router';
import Binary from './binary';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { StoreContext } from './lib/Store';
import { useContext, useEffect, useState } from 'react';
import CloudFree from './CloudFree';
import IAS from './IAS';
import HomeAssistant from './HomeAssistant';

const handlePaths = (path) => {
  switch (path) {
    case '/cloudfree':
      return <CloudFree />;
    case '/ias':
      return <IAS />;
    case '/ha':
      return <HomeAssistant />;
    default:
      return <CloudFree />;
  }
}

function App() {
  const [path, setPath] = useState('/');
  const { state } = useContext(StoreContext);

  // Configuration data
  const appName = 'Carenuity';
  const logoUrl = '/assets/img/logo/logo.png';
  const slogan = 'Lighting the chip world';

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname.startsWith('/cloudfree')) {
      setPath('/cloudfree');
    } else if (pathname.startsWith('/ias')) {
      setPath('/ias');
    } else if (pathname.startsWith('/ha')) {
      setPath('/ha');
    } else {
      setPath('/');
    }
  }, []);

  return (
    <Router>
      <Header appName={appName} logoUrl={logoUrl} slogan={slogan} />
      {/* <!-- End Header --> */}

      <Sidebar />
      {/* <!-- End Sidebar--> */}

      <main id='main' className='main'>
        <Routes>
          <Route
            path='/:group/:id/:board'
            element={
              <Binary
                image={state.data?.image}
                name={state.data?.name}
                occupation={state.data?.occupation}
                socials={state.data?.socials}
              />
            }
          />
          <Route exact path='/cloudfree' element={<CloudFree />} />
          <Route exact path='/ias' element={<IAS />} />
          <Route exact path='/ha' element={<HomeAssistant />} />
          <Route exact path='/' element={<Navigate to={'/cloudfree'} />} />
          <Route path='*' element={handlePaths(path)} />
        </Routes>
      </main>
      {/* <!-- End Main--> */}

      <Footer appName={appName} />
      {/* <!-- ======= End Footer ======= --> */}
    </Router>
  );
}

export default App;
